<template>
  <div>
    <div
      v-if="asset"
      class="poster-component mx-md-2"
      :style="calculatedBackground"
    >
      <router-link :to="url">
        <lazy-image
          type="poster"
          class="poster"
          :src="asset.poster.mid"
          :alt="asset.title"
          :title="asset.title"
        />
        <div class="box">
          <h3 class="title">{{ asset.title }}</h3>
          <span>{{ asset.genres.take(2).join(", ") }}</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import LazyImage from "@/components/utils/LaziImage.vue";

export default {
  name: "PosterComponent",
  components: { LazyImage },
  props: {
    asset: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  computed: {
    url() {
      let url = this.$t("movie_route", { slug: this.asset.slug });
      if (this.asset.type === "series") {
        url = this.$t("serie_route", { slug: this.asset.slug });
      }
      return url;
    },
    calculatedBackground() {
      if (this.asset) {
        return {
          background:
            'url("' +
            this.imgUrl("/img/poster-background.png") +
            '") no-repeat bottom center',
          backgroundSize: "contain",
        };
      }
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.poster-component {
  padding: 1em;
  * {
    text-decoration: none;
  }
  .title {
    color: #ffffff;
    height: 1.6em;
  }
  .box {
    padding: 1em;
    line-height: 1em;
    h3 {
      font-size: 1.2em;
      line-height: 1em;
      font-weight: 400;
    }
    span {
      font-size: 0.8em;
      font-weight: 400;
      color: $gray-2;
    }
  }

  .poster {
    width: 100%;
    aspect-ratio: 33/45; //79 / 95;
    display: block;
    border-radius: 16px;
  }

  @media (max-width: 760px) {
    .title {
      height: auto;

      .box {
        span {
          color: $gray-3;
          font-size: 1em;
          font-weight: 200;
        }
      }
    }
  }
  
  @media (min-width: 1920px) {
    .box{
      font-size: 0.7vw;
    }
  }
}
</style>
